import { FC, ReactNode } from 'react';
import useComputedStyles from "@/theme/useComputedStyles";
import {headingStyles} from "@/components/ui/typography/typography.styles";
import Text from '@/components/ui/typography/Text';

export interface HeadingProps {
	tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'; // Specify valid heading tags
	className?: string;
	label?: string;
	invert?: boolean;
	children?: ReactNode; // Optional children prop for flexibility
}

const Heading: FC<HeadingProps> = ({
	tag: Tag = 'h3',
	className = '',
	label,
	invert = false,
	children
	// Spread any additional props for label customization
}) => {
	const headingClassNames = useComputedStyles(
		[headingStyles],
		{
			normal: !invert,
			invert: invert,
			withSubheading: !!label
		},
		[Tag],
		className
	);

	return (
		<div className="__heading_wrapper">
			{children && <Tag className={headingClassNames}>{children}</Tag>}
			{label && (
				// Apply customization props to the Text component for the label as needed
				<Text type="secondary" size="sm">
					{label}
				</Text>
			)}
		</div>
	);
};

export default Heading;
